import { useEffect, useState } from 'react';
import ExercisesListVirtualized from 'containers/partials/lists/ExercisesListVirtualized';
import Loader from 'components/loader/Loader';
import { useStore } from 'stores/Store';
import useExercises from 'hooks/queries/useExercises';

const ExercisesListFiltered = ({ entityId, edit, filter, onPreview }) => {
  const { fetchExercises } = useExercises(entityId);
  const selectExercises = useStore(state => state.selectExercises);
  const selectedExercises = useStore(state => state.selectedExercises);
  const [loading, setLoading] = useState(false);

  const [exercises, setExercises] = useState([]);

  useEffect(() => {
    const getExercises = async () => {
      setLoading(true);
      const exercises = await fetchExercises({ ...filter });
      setExercises(exercises);
      setLoading(false);
    };

    getExercises();
  }, []);

  return (
    <div className="c-accordion__virtualized-list-wrapper">
      {loading ? (
        <Loader />
      ) : (
        <ExercisesListVirtualized
          entityId={entityId}
          wrappedList
          onPreview={onPreview}
          visible={edit}
          checkable={edit}
          showLevel
          enablePreviewModal
          exercises={exercises}
          onSelect={exercise => {
            if (!edit) return;
            selectExercises(exercise);
          }}
          selectedExercises={selectedExercises}
        />
      )}
    </div>
  );
};

ExercisesListFiltered.propTypes = {};

export default ExercisesListFiltered;
